
// Date formatting utility
// Maps application language codes to standard locales


function getLocale(lang) {
    // If lang starts with 'tl', use 'tl-PH', otherwise default to 'en-PH'
    return lang && lang.startsWith('tl') ? 'tl-PH' : 'en-PH';
}

export function formatDate(dateString, lang = 'en') {
    if (!dateString) return '';

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) return 'Invalid Date';

    const locale = getLocale(lang);

    // Format: December 6, 2025 at 2:00 PM
    return date.toLocaleString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
}

// Format date only (no time)
export function formatDateOnly(dateString, lang = 'en') {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';

    const locale = getLocale(lang);

    return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

// Format time only
export function formatTimeOnly(dateString, lang = 'en') {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Time';

    const locale = getLocale(lang);

    return date.toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
}
